module.exports = __webpack_public_path__ + "img/0.0d2f0124.png";